import React from 'react'
import { Field, getFormValues,InjectedFormProps, reduxForm } from 'redux-form'
import { Button, Col, Row } from 'reactstrap'
import { TextField } from 'common-fields'
import { connect } from 'react-redux'
import "../../scss/riskSettings.scss"
import { NormalizeNumber,NormalizeCurrency } from 'dynamic-questionarie'
import { RiskEnums } from '../../utils/RiskUtils'
import { useLocation } from 'react-router-dom'
interface FormErrors {
  [key: string]: string | undefined; 
}

const validate = (values:any) => {
  const errors: FormErrors = {};
  Object.entries(values).forEach(([key, value]) => {
    if (!value) {
      errors[key] = "Required";
    }
  });
  return errors;
}

const RiskQuestionnarieForm: React.FC<
  any & InjectedFormProps<Record<string, unknown>, any>
> = (props: any) => {
  const { questionsData, onSaveQuestion,headerText,handleSubmit,handleToggle,handleMoveStatus } = props
  const location = useLocation()
  const edit = location.state.editable;

  const onTextBlur = (
    event: FocusEvent,
    riskParameterId: number,

  ) => {
    event.preventDefault();
    if (props.formValues["question_" + riskParameterId] !== undefined || null) {
      const currentQuestion = questionsData.find(
        (m: any) => m.riskParameterId == riskParameterId
      );
      if (currentQuestion) {
        onSaveQuestion({
          questionData: {
            [riskParameterId]:
              props.formValues["question_" + riskParameterId],
          }
        });
      }
    }

  };

  const renderQuestionField = (question: any) => {
    if (question.parameterType === RiskEnums.CURRENCY) {
      return (
        <Field
          component={TextField}
          name={"question_" + question.riskParameterId.toString()}
          label={question.parameterText}
          textBlur={(event: FocusEvent) =>
            onTextBlur(event, question.riskParameterId)
          }
          disabled={!edit}
        normalize={NormalizeCurrency}
        />
      )
    }
    else if (question.parameterType === RiskEnums.NUMERICID) {
      return (
        <Field
          component={TextField}
          name={"question_" + question.riskParameterId.toString()}
          label={question.parameterText}
          textBlur={(event: FocusEvent) =>
            onTextBlur(event, question.riskParameterId)
          }
          disabled={!edit}
        normalize={NormalizeNumber}
        />
      )
    }
  }

  const renderQuestions = () => {
    return props?.questionsData && props?.questionsData.length > 0 && props?.questionsData.map((question: any) => {
      return (
        <Col key={question.riskParameterId} sm="9" md={9}>
          {renderQuestionField(question)}
        </Col>
      )
    })
  }

  return (
    <>
      <form className="riskForm" autoComplete="off" onSubmit={handleSubmit(handleMoveStatus)}>
        <Row className="riskContainer">
        <div className="header">{headerText}</div>
          {renderQuestions()}
          <Button className="riskSubmitBtn"  type="submit" disabled={props.invalid || !edit}>Submit</Button>
          <div className="completeText" onClick={handleToggle}>Complete this later</div>
        </Row>
        
      </form>
    </>

  )
}

export default connect((state: any, props: any) => {
  return {
    initialValues: props.formIntialValues,
    formValues: getFormValues("RiskQuestionnarieForm")(state),
    form: "RiskQuestionnarieForm",
  };
})(
  reduxForm<Record<string, unknown>, any>({
    enableReinitialize: true,
    keepDirtyOnReinitialize:true,
    validate,
  })(RiskQuestionnarieForm)
)